import React from "react";

import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import Button from "Theme/Button";

import { openModal } from "./redux";

import type { Dispatch } from "redux";

type Props = {
  name: string;
  onClick: (arg0: MouseEvent) => void;
  trackType?: string;
  trackId?: string;
  color?: "blue" | "gray" | "white" | "link" | "link-white" | "deprecated-link";
};

const ReduxTriggerButtonDumb = ({ trackType, trackId, color, ...rest }: Props) => (
  <Button
    classicProps={{
      color: color || "link",
    }}
    intuitProps={{
      color: color || "link",
    }}
    cobaltProps={{
      color: color || "tertiary",
    }}
    {...rest}
  />
);

type OwnProps = {
  name: string;
  onClick?: (arg0: MouseEvent) => void;
  trackType?: string;
  trackId?: string;
};

const mapDispatchToProps = (dispatch: Dispatch<any>, { name, onClick, trackType, trackId }: OwnProps) => ({
  onClick: (e: MouseEvent) => {
    if (e.target instanceof HTMLElement) {
      if (e.target.baseURI !== null) {
        const uri = e.target.baseURI;
        const location = typeof uri === "string" || uri instanceof String ? uri.split("/") : [];
        let properties = {
          label: trackId || (e.target instanceof HTMLElement && e.target.innerText),
          location: location[location.length - 1].replace("-", "_"),
        };

        if (trackType && trackId) {
          properties = {
            ...properties,
            type: trackType,
            deprecatedName: `cta_clicked/${trackType}/${trackId}`,
          };
        }

        AnalyticsTracking.trackEvent("cta_clicked", properties);

        if (typeof onClick === "function") {
          onClick(e);
        }

        if (!e.defaultPrevented) {
          dispatch(openModal(name));
          e.preventDefault();
        }
      }
    }
  },
});

export const ReduxTriggerButton = connect(null, mapDispatchToProps)(ReduxTriggerButtonDumb);
